module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hFY5k"))).then(() => parcelRequire('d0iPb'));